import { render, staticRenderFns } from "./SectionMedia.vue?vue&type=template&id=c3260fc6&scoped=true"
import script from "./SectionMedia.vue?vue&type=script&lang=ts"
export * from "./SectionMedia.vue?vue&type=script&lang=ts"
import style0 from "./SectionMedia.vue?vue&type=style&index=0&id=c3260fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3260fc6",
  null
  
)

export default component.exports